import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { fetchGoals } from './data';

export const useGoalsQuery = () => {
  const {
    data: goalsData,
    isLoading: isLoadingGoals,
    error: goalsError,
    refetch: refetchGoals,
  } = useQuery(['goals'], fetchGoals);

  const goals = useMemo(() => {
    return (
      goalsData?.map(goal => ({
        id: goal.id,
        goal: goal.name,
        planYear: goal.plan_year,
        position: goal.position,
        createdAt: goal.created_at,
      })) || []
    );
  }, [goalsData]);

  return {
    goals,
    isLoadingGoals,
    goalsError,
    refetchGoals,
  };
};
